module.exports = __webpack_public_path__ + "img/11.7f16c110.png";